import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { StyledTagCloseButton } from '../../components/TagCloseButton/TagCloseButton.styles';
import { buttonStateMixin } from '../buttonStateMixin';
import { disabledMixin } from '../disabledMixin';
import { sizeMixin } from '../sizeMixin';
import { typographyMixin } from '../typographyMixin';
import { ChipMixin } from './ChipMixin';

/** @class InputChipMixin */
/** @method */
export var InputChipMixin = function InputChipMixin(props) {
  return token({
    borderWidth: "Chip.pressed.borderWidth",
    color: "Chip.fontColor",
    closeButtonColorActive: 'Chip.closeButton.colorActive',
    closeButtonOpacityActive: 'Chip.closeButton.opacityActive',
    focusShadow: 'Chip.boxShadow.focus',
    fontType: "Chip.fontType",
    height: "Chip.height"
  }, function (_ref) {
    var borderWidth = _ref.borderWidth,
      color = _ref.color,
      closeButtonColorActive = _ref.closeButtonColorActive,
      closeButtonOpacityActive = _ref.closeButtonOpacityActive,
      focusShadow = _ref.focusShadow,
      fontType = _ref.fontType,
      height = _ref.height;
    return css(["", " display:inline-flex;align-items:center;vertical-align:top;border:", "px solid;&:focus-within{box-shadow:", ";}& > ", "{margin-top:0;}", "{color:", ";margin-left:0;", "{box-shadow:none;}&[aria-disabled='false']:active{color:", ";opacity:", ";}&[aria-disabled='true']:hover,&[aria-disabled='true']:active{opacity:1;}}", " ", " ", " ", ""], ChipMixin(props), borderWidth, focusShadow, StyledIcon, StyledTagCloseButton, color, StyledIcon, closeButtonColorActive, closeButtonOpacityActive, buttonStateMixin('Pressed')(Object.assign({
      buttonType: 'tertiary',
      interactive: false
    }, props)), disabledMixin(props), sizeMixin({
      fontType: fontType,
      borderWidth: borderWidth * 2,
      size: height
    })(props), typographyMixin(Object.assign({}, props, {
      fontType: fontType,
      fontTypeIconAlignment: false
    })));
  })(props);
};